import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, Fragment as _Fragment, vModelDynamic as _vModelDynamic, withDirectives as _withDirectives, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "w-full bg-slate-50 dark:bg-gray-900" }
const _hoisted_2 = { class: "flex" }
const _hoisted_3 = { class: "relative flex-1 w-full" }
const _hoisted_4 = { class: "px-4 sm:px-6 py-6 space-y-6 max-w-7xl mx-auto" }
const _hoisted_5 = {
  key: 0,
  class: "rounded-2xl overflow-hidden shadow-xl bg-gray-100 dark:bg-gray-800 p-6"
}
const _hoisted_6 = { class: "flex items-center gap-5" }
const _hoisted_7 = { class: "flex-1 space-y-3" }
const _hoisted_8 = {
  key: 1,
  class: "relative rounded-2xl overflow-hidden shadow-xl",
  style: {"background":"linear-gradient(135deg, #4a1f61 0%, #6c328b 45%, #75a321 100%)"}
}
const _hoisted_9 = { class: "flex flex-col sm:flex-row sm:items-center gap-5 px-4 sm:px-6 py-6" }
const _hoisted_10 = { class: "relative shrink-0 self-center sm:self-auto" }
const _hoisted_11 = { class: "h-20 sm:h-24 w-20 sm:w-24 rounded-full border-4 border-white/30 overflow-hidden shadow-lg bg-white/10" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "flex-1 min-w-0 text-center sm:text-left" }
const _hoisted_14 = { class: "text-xl sm:text-2xl font-bold text-white" }
const _hoisted_15 = { class: "flex items-center justify-center sm:justify-start gap-1.5 mt-1 text-sm text-white/80" }
const _hoisted_16 = { class: "truncate" }
const _hoisted_17 = {
  key: 0,
  class: "mt-2 inline-flex items-center rounded-full border border-white/40 px-3 py-0.5 text-xs font-medium text-white"
}
const _hoisted_18 = {
  key: 2,
  class: "flex gap-4"
}
const _hoisted_19 = {
  key: 3,
  class: "flex gap-1 border-b border-gray-200 dark:border-gray-700"
}
const _hoisted_20 = { class: "grid grid-cols-1 gap-6 lg:grid-cols-2" }
const _hoisted_21 = { class: "grid grid-cols-1 gap-6 lg:grid-cols-2" }
const _hoisted_22 = { class: "rounded-2xl dark:bg-gray-800 border dark:border-gray-700 shadow-sm" }
const _hoisted_23 = { class: "flex items-center gap-2 px-6 py-4 border-b dark:border-gray-700" }
const _hoisted_24 = { class: "px-6 py-5 grid grid-cols-2 gap-x-8 gap-y-5" }
const _hoisted_25 = { class: "mt-0.5 text-base font-semibold dark:text-white" }
const _hoisted_26 = { class: "mt-0.5 text-base font-semibold dark:text-white" }
const _hoisted_27 = { class: "mt-0.5 text-base font-semibold dark:text-white" }
const _hoisted_28 = { class: "mt-0.5 text-base font-semibold dark:text-white" }
const _hoisted_29 = { class: "mt-0.5 text-base font-semibold dark:text-white break-all" }
const _hoisted_30 = { class: "mt-0.5 text-base font-semibold dark:text-white" }
const _hoisted_31 = { class: "col-span-2" }
const _hoisted_32 = { class: "mt-0.5 text-base font-semibold dark:text-white" }
const _hoisted_33 = { class: "rounded-2xl dark:bg-gray-800 border dark:border-gray-700 shadow-sm" }
const _hoisted_34 = { class: "flex items-center gap-2 px-6 py-4 border-b dark:border-gray-700" }
const _hoisted_35 = { class: "px-6 py-5 grid grid-cols-2 gap-x-8 gap-y-5" }
const _hoisted_36 = { class: "mt-0.5 text-base font-semibold dark:text-white" }
const _hoisted_37 = { class: "mt-0.5 text-base font-semibold dark:text-white" }
const _hoisted_38 = { class: "mt-0.5 text-base font-semibold dark:text-white" }
const _hoisted_39 = { class: "mt-0.5 text-base font-semibold dark:text-white" }
const _hoisted_40 = { class: "rounded-2xl dark:bg-gray-800 border dark:border-gray-700 shadow-sm lg:w-1/2" }
const _hoisted_41 = { class: "flex items-center gap-2 px-6 py-4 border-b dark:border-gray-700" }
const _hoisted_42 = { class: "px-6 py-5 space-y-5" }
const _hoisted_43 = { class: "mt-0.5 text-base font-semibold dark:text-white" }
const _hoisted_44 = { class: "mt-0.5 text-base font-bold dark:text-white" }
const _hoisted_45 = { class: "mt-1 flex items-center gap-1.5" }
const _hoisted_46 = { class: "rounded-2xl dark:bg-gray-800 border dark:border-gray-700 shadow-sm" }
const _hoisted_47 = { class: "flex items-center gap-2 px-6 py-4 border-b dark:border-gray-700" }
const _hoisted_48 = { class: "px-6 py-5 space-y-4 max-w-md" }
const _hoisted_49 = {
  key: 0,
  class: "text-sm text-red-400"
}
const _hoisted_50 = { class: "relative" }
const _hoisted_51 = ["type"]
const _hoisted_52 = { class: "relative" }
const _hoisted_53 = ["type"]
const _hoisted_54 = { class: "relative" }
const _hoisted_55 = ["type"]
const _hoisted_56 = {
  key: 0,
  class: "mt-1 text-xs text-red-400"
}
const _hoisted_57 = ["disabled"]
const _hoisted_58 = {
  key: 0,
  class: "space-y-4"
}
const _hoisted_59 = { class: "rounded-xl overflow-hidden border border-slate-200 bg-slate-50" }
const _hoisted_60 = { class: "flex items-center justify-end gap-2" }
const _hoisted_61 = { class: "px-3 py-1.5 rounded-lg text-xs font-medium text-slate-600 hover:bg-slate-100 transition cursor-pointer" }
const _hoisted_62 = {
  key: 0,
  class: "mt-1 text-xs text-red-600"
}
const _hoisted_63 = ["disabled"]
const _hoisted_64 = { class: "flex items-center justify-center p-2" }
const _hoisted_65 = ["src"]

import { computed, reactive, ref, watch, onMounted, onBeforeUnmount } from 'vue'
import { User, ShieldCheck, Pencil, Lock, Camera, Mail, GraduationCap, ChevronLeft, Eye, EyeOff, RotateCcw, RotateCw } from 'lucide-vue-next'
import api from '@/services/api'
import { positionService, type Position } from '@/services/positionService'
import { useAuthStore } from '@/stores/auth'
import { getAvatarColors } from '@/utils/avatarColor'
import ProfilePersonalModal from '@/components/profile/ProfilePersonalModal.vue'
import ProfileEmailModal from '@/components/profile/ProfileEmailModal.vue'
import ProfilePasswordModal from '@/components/profile/ProfilePasswordModal.vue'
import ProfileDocumentsTab from '@/components/profile/ProfileDocumentsTab.vue'
import Modal from '@/components/layout/Modal.vue'
import VueCropper from 'vue-cropperjs'
import 'cropperjs/dist/cropper.css'
import Skeleton from '@/components/ui/Skeleton.vue'
import { useToast } from 'vue-toastification'

// Initialize toast functions
const toastTimeout = 3000

interface ProfileDetails {
  phone?: string
  address?: string
  city?: string
  state?: string
  zipcode?: string
  date_of_birth?: string
  gender?: string
  profile_picture?: string
  first_name?: string
  last_name?: string
}

interface Profile {
  id: number
  name?: string
  first_name?: string
  last_name?: string
  email: string
  username?: string
  role?: string
  status?: string
  phone?: string
  address?: string
  city?: string
  state?: string
  zipcode?: string
  date_of_birth?: string
  dob?: string
  gender?: string
  profile_picture?: string
  email_verified_at?: string
  created_at?: string
  updated_at?: string
  position_id?: number
  position?: string
  details?: ProfileDetails
}

interface ProfileResponse {
  success?: boolean
  data: Profile
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ProfileView',
  setup(__props) {

const toast = useToast()
const getErrorMessage = (err: unknown, defaultMessage: string): string => {
  const axiosError = err as { response?: { status?: number; data?: { message?: string; errors?: Record<string, string[]> } } }
  const status = axiosError.response?.status
  const data = axiosError.response?.data

  if (status === 404) {
    return 'The requested resource was not found. Please try again later.'
  }
  if (status === 403) {
    return 'You do not have permission to perform this action.'
  }
  if (status === 500) {
    return 'A server error occurred. Please try again later.'
  }
  if (status === 422 && data?.errors) {
    const firstField = Object.keys(data.errors)[0]
    const firstError = data.errors[firstField]?.[0]
    return firstError || defaultMessage
  }
  if (status === 422 && data?.message) {
    return data.message
  }
  return defaultMessage
}

const authStore = useAuthStore()

const user = reactive({
	id: 0,
	name: '',
	firstName: '',
	lastName: '',
	username: '',
	role: '',
	status: '',
	dateOfBirth: '',
	gender: '',
	address: '',
	city: '',
	state: '',
	zipcode: '',
	phone: '',
	email: '',
	emailVerifiedAt: '',
	createdAt: '',
	updatedAt: '',
	avatar: '',
	position: ''
})

const loading = ref(false)
const profileLoading = ref(true)
const activeTab = ref<'personal' | 'documents'>('personal')
const error = ref('')
const fileInputRef = ref<HTMLInputElement | null>(null)
const showAvatarPreview = ref(false)
const cropperRef = ref<any>(null)
const avatarFile = ref<File | null>(null)
const avatarPreview = ref('')
const positions = ref<Position[]>([])
const showCurrentPw = ref(false)
const showNewPw = ref(false)
const showConfirmPw = ref(false)

const editing = reactive({
  personal: false,
  email: false,
  password: false,
  avatar: false
})

const passwordForm = reactive({
  currentPassword: '',
  newPassword: '',
  confirmPassword: ''
})

const draft = reactive({
  firstName: '',
  lastName: '',
  username: '',
  dateOfBirth: '',
  gender: '',
  address: '',
  city: '',
  state: '',
  zipcode: '',
  phone: '',
  email: '',
  positionId: null as number | null
})

const hasAvatar = computed(() => Boolean(user.avatar))

const avatarInitial = computed(() => {
  const raw = user.firstName || user.lastName || user.username || user.name || user.email
  const initial = raw.trim().charAt(0).toUpperCase()
  return initial
})

const displayName = computed(() => {
  const combined = [user.firstName, user.lastName].filter(Boolean).join(' ')
  return combined || user.name || '-'
})

const avatarSeed = computed(() =>
  String(user.id || user.email || user.username || user.firstName || user.lastName || 'user')
)

const avatarColors = computed(() => getAvatarColors(avatarSeed.value))

const avatarFillStyle = computed(() => ({
  backgroundColor: avatarColors.value.primary
}))

const formattedDateOfBirth = computed(() => {
	if (!user.dateOfBirth) return '-'
	
	const match = user.dateOfBirth.match(/^(\d{4})-(\d{2})-(\d{2})/)
	if (!match) {
		const date = new Date(user.dateOfBirth)
		if (Number.isNaN(date.getTime())) return '-'
		return date.toLocaleDateString('en-US', {
		year: 'numeric',
		month: 'long',
		day: 'numeric'
		})
	}
	
	const [, year, month, day] = match
	const monthNames = [
		'January', 'February', 'March', 'April', 'May', 'June',
		'July', 'August', 'September', 'October', 'November', 'December'
	]
	const monthName = monthNames[parseInt(month, 10) - 1]
	return `${monthName} ${parseInt(day, 10)}, ${year}`
})

const formattedRole = computed(() => {
	const raw = (user.role || '').trim()
	if (!raw) return '-'
	return raw.charAt(0).toUpperCase() + raw.slice(1)
})

const closeAll = () => {
	editing.personal = false
	editing.email = false
	editing.password = false
	editing.avatar = false
	passwordForm.currentPassword = ''
	passwordForm.newPassword = ''
	passwordForm.confirmPassword = ''
	if (avatarPreview.value) {
		URL.revokeObjectURL(avatarPreview.value)
		avatarPreview.value = ''
	}
	error.value = ''
}

const handleFileSelected = (event: Event) => {
	const target = event.target as HTMLInputElement
	const file = target.files?.[0]
	if (!file) return

	avatarFile.value = file
	if (avatarPreview.value) {
		URL.revokeObjectURL(avatarPreview.value)
	}
	avatarPreview.value = URL.createObjectURL(file)
	error.value = ''
	editing.avatar = true

	// Reset the input so the same file can be selected again
	target.value = ''
}

watch(avatarPreview, (newVal) => {
	if (cropperRef.value && newVal) {
		cropperRef.value.replace(newVal)
	}
})

const rotateCropper = (deg: number) => {
	cropperRef.value?.rotate(deg)
}

const handleCropAndSave = async () => {
	if (!cropperRef.value) {
		error.value = 'Please choose an image to upload'
		return
	}

	const canvas = cropperRef.value.getCroppedCanvas({
		width: 300,
		height: 300,
	})
	canvas.toBlob(async (blob: Blob | null) => {
		if (blob) {
			await handleAvatarSave(blob)
		}
	}, 'image/jpeg', 0.9)
}

const getProfileName = (profile: Profile) => {
	const combined = [profile.first_name, profile.last_name].filter(Boolean).join(' ')
	return profile.name || combined
}

const normalizeGender = (value?: string) => {
	const raw = (value || '').trim().toLowerCase()
	if (!raw) return ''
	if (raw === 'male' || raw === 'm') return 'Male'
	if (raw === 'female' || raw === 'f') return 'Female'
	if (raw === 'other') return 'Other'
	if (raw === 'prefer not to say' || raw === 'prefer_not_to_say' || raw === 'prefer-not-to-say') {
		return 'Prefer not to say'
	}
	return raw.replace(/\b\w/g, (c) => c.toUpperCase())
}

const normalizeDateInput = (value?: string) => {
	const raw = (value || '').trim()
	if (!raw) return ''
	if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) return raw
	const date = new Date(raw)
	if (Number.isNaN(date.getTime())) return ''
	const year = date.getUTCFullYear()
	const month = String(date.getUTCMonth() + 1).padStart(2, '0')
	const day = String(date.getUTCDate()).padStart(2, '0')
	return `${year}-${month}-${day}`
}

const normalizeAddress = (profile: Profile) => {
	const d = profile.details
	if (d && (d.address || d.city || d.state || d.zipcode)) {
		return {
		address: d.address ?? '',
		city: d.city ?? '',
		state: d.state ?? '',
		zipcode: d.zipcode ?? ''
		}
	}
	return {
	address: profile.address ?? '',
	city: profile.city ?? '',
	state: profile.state ?? '',
	zipcode: profile.zipcode ?? ''
	}
}

const syncUserFromProfile = (profile: Profile) => {
	const firstName = profile.first_name ?? ''
	const lastName = profile.last_name ?? ''
	const baseName = firstName || lastName ? `${firstName} ${lastName}`.trim() : (profile.name || '')

	const address = normalizeAddress(profile)
	user.id = profile.id ?? 0
	user.name = baseName
	user.firstName = firstName
	user.lastName = lastName
	user.username = profile.username ?? (profile.email?.split('@')[0] || '')
	user.role = profile.role ?? 'User'
	user.status = profile.status ?? ''
	const nextDateOfBirth = profile.details?.date_of_birth ?? profile.date_of_birth ?? profile.dob
	user.dateOfBirth = nextDateOfBirth !== undefined ? nextDateOfBirth : user.dateOfBirth
	const nextGender = profile.details?.gender ?? profile.gender
	user.gender = nextGender !== undefined ? normalizeGender(nextGender) : user.gender
	user.address = address.address
	user.city = address.city
	user.state = address.state
	user.zipcode = address.zipcode
	user.phone = profile.details?.phone ?? profile.phone ?? ''
	user.email = profile.email ?? ''
	user.emailVerifiedAt = profile.email_verified_at ?? ''
	user.createdAt = profile.created_at ?? ''
	user.updatedAt = profile.updated_at ?? ''
	user.avatar = profile.profile_picture || ''
	user.position = profile.position ?? ''

	draft.firstName = user.firstName
	draft.lastName = user.lastName
	draft.username = user.username
	draft.dateOfBirth = normalizeDateInput(user.dateOfBirth)
	draft.gender = user.gender
	draft.address = user.address
	draft.city = user.city
	draft.state = user.state
	draft.zipcode = user.zipcode
	draft.phone = user.phone
	draft.email = user.email
	draft.positionId = profile.position_id ?? null
}

const updateAuthCache = (profile: Profile) => {
	const display = getProfileName(profile)
	authStore.user = {
		id: profile.id,
		name: display,
		email: profile.email,
		role: profile.role,
		position_id: profile.position_id,
		position: profile.position,
		profile_picture: profile.profile_picture
	}

	const storage = sessionStorage.getItem('token')
		? sessionStorage
		: localStorage.getItem('token')
		? localStorage
		: null

	if (storage) {
		storage.setItem('user', JSON.stringify(authStore.user))
	}
}

const fetchProfile = async () => {
	profileLoading.value = true
	error.value = ''
	try {
		const [profileResponse, fetchedPositions] = await Promise.all([
			api.get<ProfileResponse | Profile>('/profile'),
			positionService.getPositions()
		])
		const data = (profileResponse.data as ProfileResponse).data ?? (profileResponse.data as Profile)
		positions.value = fetchedPositions
		const matched = data.position_id ? fetchedPositions.find(p => p.id === data.position_id) : null
		data.position = matched ? matched.name : ''
		syncUserFromProfile(data)
		updateAuthCache(data)
	} catch (err) {
		console.error('Profile fetch error:', err)
		error.value = 'Failed to load profile'
	} finally {
		profileLoading.value = false
	}
}

// Modal save handlers
const handlePersonalSave = async (updatedDraft: typeof draft) => {
	Object.assign(draft, updatedDraft)

	const payload: Partial<Profile> = {
		first_name: draft.firstName,
		last_name: draft.lastName,
		username: draft.username,
		address: draft.address,
		city: draft.city,
		state: draft.state,
		zipcode: draft.zipcode,
		date_of_birth: draft.dateOfBirth,
		gender: draft.gender,
		phone: draft.phone,
		position_id: draft.positionId
	}

	const loadingToast = toast.info('Updating profile...', { timeout: false })
	loading.value = true
	error.value = ''
	try {
		const response = await api.put<ProfileResponse | Profile>('/profile', payload)
		const data = (response.data as ProfileResponse).data ?? (response.data as Profile)
		syncUserFromProfile(data)
		updateAuthCache(data)
		closeAll()
		toast.dismiss(loadingToast)
		toast.success('Profile updated successfully', { timeout: toastTimeout })
		setTimeout(() => window.location.reload(), 800)
	} catch (err) {
		console.error('Profile update error:', err)
		toast.dismiss(loadingToast)
		const errorMessage = getErrorMessage(err, 'Failed to update profile')
		toast.error(errorMessage, { timeout: toastTimeout })
		error.value = errorMessage
	} finally {
		loading.value = false
	}
}

const handleEmailSave = async (updatedDraft: typeof draft) => {
	Object.assign(draft, updatedDraft)

	const payload: Partial<Profile> = {
		email: draft.email
	}

	const loadingToast = toast.info('Updating email...', { timeout: false })
	loading.value = true
	error.value = ''
	try {
		const response = await api.put<ProfileResponse | Profile>('/profile', payload)
		const data = (response.data as ProfileResponse).data ?? (response.data as Profile)
		syncUserFromProfile(data)
		updateAuthCache(data)
		closeAll()
		toast.dismiss(loadingToast)
		toast.success('Email updated successfully', { timeout: toastTimeout })
	} catch (err) {
		console.error('Email update error:', err)
		toast.dismiss(loadingToast)
		const errorMessage = getErrorMessage(err, 'Failed to update email')
		toast.error(errorMessage, { timeout: toastTimeout })
		error.value = errorMessage
	} finally {
		loading.value = false
	}
}

const handlePasswordSave = async (updatedPasswordForm: typeof passwordForm) => {
	Object.assign(passwordForm, updatedPasswordForm)

	if (!passwordForm.currentPassword || !passwordForm.newPassword || !passwordForm.confirmPassword) {
		toast.error('Please complete all password fields', { timeout: toastTimeout })
		return
	}
	if (passwordForm.newPassword.length < 8) {
		toast.error('New password must be at least 8 characters', { timeout: toastTimeout })
		return
	}
	if (passwordForm.newPassword !== passwordForm.confirmPassword) {
		toast.error('Passwords do not match', { timeout: toastTimeout })
		return
	}
	if (passwordForm.newPassword === passwordForm.currentPassword) {
		toast.error('New password must be different from current password', { timeout: toastTimeout })
		return
	}

	const loadingToast = toast.info('Changing password...', { timeout: toastTimeout })
	loading.value = true
	error.value = ''
	try {
		await api.post('/profile/password', {
			current_password: passwordForm.currentPassword,
			password: passwordForm.newPassword,
			password_confirmation: passwordForm.confirmPassword
		})
		closeAll()
		toast.dismiss(loadingToast)
		toast.success('Password changed successfully', { timeout: toastTimeout })
	} catch (err) {
		toast.dismiss(loadingToast)
		const message =
		(err as { response?: { data?: { message?: string } } })?.response?.data?.message ||
		'Failed to change password'
		toast.error(message, { timeout: toastTimeout })
		error.value = message
	} finally {
		loading.value = false
	}
}

const handleAvatarSave = async (croppedBlob?: Blob) => {
	if (!croppedBlob) {
		error.value = 'Please choose an image to upload'
		return
	}

	const formData = new FormData()
	formData.append('avatar', croppedBlob, 'avatar.jpg')

	loading.value = true
	error.value = ''
	try {
		const config = {
			headers: { 'Content-Type': 'multipart/form-data' },
			skipGlobalError: true
		}
		const response = await api.post<ProfileResponse | Profile>('/profile/avatar', formData, config as any)
		const data = (response.data as ProfileResponse).data ?? (response.data as Profile)
		syncUserFromProfile(data)
		updateAuthCache(data)
		toast.success('Profile picture updated successfully', { timeout: toastTimeout })
		closeAll()
	} catch (err) {
		console.error('Avatar upload error:', err)
		const errorMessage = getErrorMessage(err, 'Failed to upload profile picture')
		toast.error(errorMessage, { timeout: toastTimeout })
		error.value = errorMessage
	} finally {
		loading.value = false
	}
}

onMounted(() => {
  	fetchProfile()
})

onBeforeUnmount(() => {
   	// Cleanup if needed
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("main", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            type: "button",
            class: "flex items-center gap-1 text-sm text-slate-400 transition",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back()))
          }, [
            _createVNode(_unref(ChevronLeft), { class: "h-4 w-4" }),
            _cache[17] || (_cache[17] = _createTextVNode(" Back ", -1))
          ]),
          (profileLoading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(Skeleton, {
                    variant: "block",
                    w: "w-24",
                    h: "h-24",
                    "class-name": "rounded-full shrink-0"
                  }),
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(Skeleton, {
                      variant: "block",
                      h: "h-7",
                      w: "w-48"
                    }),
                    _createVNode(Skeleton, {
                      variant: "block",
                      h: "h-4",
                      w: "w-64"
                    }),
                    _createVNode(Skeleton, {
                      variant: "block",
                      h: "h-6",
                      w: "w-28",
                      "class-name": "rounded-full"
                    })
                  ]),
                  _createVNode(Skeleton, {
                    variant: "block",
                    h: "h-10",
                    w: "w-32",
                    "class-name": "rounded-lg shrink-0"
                  })
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      (hasAvatar.value)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (showAvatarPreview.value = true)),
                            class: "h-full w-full"
                          }, [
                            _createElementVNode("img", {
                              src: user.avatar,
                              alt: "profile",
                              class: "h-full w-full object-cover cursor-pointer hover:opacity-90 transition-opacity"
                            }, null, 8, _hoisted_12)
                          ]))
                        : (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            class: "flex h-full w-full items-center justify-center text-3xl font-bold text-white",
                            style: _normalizeStyle(avatarFillStyle.value)
                          }, _toDisplayString(avatarInitial.value), 5))
                    ]),
                    _createElementVNode("button", {
                      type: "button",
                      class: "absolute bottom-0 right-0 grid h-7 w-7 place-items-center rounded-full bg-white/20 hover:bg-white/40 hover:scale-110 text-white transition-all group",
                      title: "Change photo",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (fileInputRef.value?.click()))
                    }, [
                      _createVNode(_unref(Camera), { class: "h-3.5 w-3.5" }),
                      _cache[18] || (_cache[18] = _createElementVNode("span", { class: "absolute -top-8 left-1/2 -translate-x-1/2 whitespace-nowrap rounded bg-black/70 px-2 py-1 text-xs text-white opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none" }, " Change photo ", -1))
                    ]),
                    _createElementVNode("input", {
                      ref_key: "fileInputRef",
                      ref: fileInputRef,
                      type: "file",
                      accept: "image/*",
                      class: "hidden",
                      onChange: handleFileSelected
                    }, null, 544)
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("h1", _hoisted_14, _toDisplayString(displayName.value), 1),
                    _createElementVNode("div", _hoisted_15, [
                      _createVNode(_unref(Mail), { class: "h-3.5 w-3.5 shrink-0" }),
                      _createElementVNode("span", _hoisted_16, _toDisplayString(user.email), 1)
                    ]),
                    (user.position)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(user.position), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    class: "w-full sm:w-auto shrink-0 inline-flex items-center justify-center gap-2 rounded-lg bg-white text-gray-800 font-semibold text-sm px-4 py-2 shadow hover:bg-white/90 transition",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (editing.personal = true))
                  }, [
                    _createVNode(_unref(Pencil), { class: "h-3.5 w-3.5" }),
                    _cache[19] || (_cache[19] = _createTextVNode(" Edit Profile ", -1))
                  ])
                ])
              ])),
          (profileLoading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _createVNode(Skeleton, {
                  variant: "block",
                  h: "h-10",
                  w: "w-36",
                  "class-name": "rounded-lg"
                }),
                _createVNode(Skeleton, {
                  variant: "block",
                  h: "h-10",
                  w: "w-28",
                  "class-name": "rounded-lg"
                })
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _createElementVNode("button", {
                  type: "button",
                  class: _normalizeClass(["px-4 py-2.5 text-sm font-semibold transition border-b-2 -mb-px", activeTab.value === 'personal'
								? 'border-primary text-primary dark:text-secondary dark:border-secondary'
								: 'border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300']),
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (activeTab.value = 'personal'))
                }, " Personal Details ", 2),
                _createElementVNode("button", {
                  type: "button",
                  class: _normalizeClass(["px-4 py-2.5 text-sm font-semibold transition border-b-2 -mb-px", activeTab.value === 'documents'
								? 'border-primary text-primary dark:text-secondary dark:border-secondary'
								: 'border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300']),
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (activeTab.value = 'documents'))
                }, " Documents ", 2)
              ])),
          (profileLoading.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                _createElementVNode("div", _hoisted_20, [
                  _createVNode(Skeleton, {
                    variant: "card",
                    "extra-lines": 8
                  }),
                  _createVNode(Skeleton, {
                    variant: "card",
                    "extra-lines": 4
                  })
                ]),
                _createVNode(Skeleton, {
                  variant: "card",
                  "class-name": "lg:w-1/2",
                  "extra-lines": 3
                }),
                _createVNode(Skeleton, {
                  variant: "card",
                  "extra-lines": 4,
                  "class-name": "max-w-md"
                })
              ], 64))
            : (activeTab.value === 'personal')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, [
                        _createVNode(_unref(User), { class: "h-5 w-5 dark:text-slate-300" }),
                        _cache[20] || (_cache[20] = _createElementVNode("h2", { class: "text-xl font-bold dark:text-white" }, "Personal Information", -1))
                      ]),
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("div", null, [
                          _cache[21] || (_cache[21] = _createElementVNode("div", { class: "text-sm text-slate-400" }, "Display Name", -1)),
                          _createElementVNode("div", _hoisted_25, _toDisplayString(displayName.value), 1)
                        ]),
                        _createElementVNode("div", null, [
                          _cache[22] || (_cache[22] = _createElementVNode("div", { class: "text-sm text-slate-400" }, "Username", -1)),
                          _createElementVNode("div", _hoisted_26, _toDisplayString(user.username || 'Not assigned'), 1)
                        ]),
                        _createElementVNode("div", null, [
                          _cache[23] || (_cache[23] = _createElementVNode("div", { class: "text-sm text-slate-400" }, "First Name", -1)),
                          _createElementVNode("div", _hoisted_27, _toDisplayString(user.firstName || 'Not provided'), 1)
                        ]),
                        _createElementVNode("div", null, [
                          _cache[24] || (_cache[24] = _createElementVNode("div", { class: "text-sm text-slate-400" }, "Last Name", -1)),
                          _createElementVNode("div", _hoisted_28, _toDisplayString(user.lastName || 'Not provided'), 1)
                        ]),
                        _createElementVNode("div", null, [
                          _cache[25] || (_cache[25] = _createElementVNode("div", { class: "text-sm text-slate-400" }, "Email Address", -1)),
                          _createElementVNode("div", _hoisted_29, _toDisplayString(user.email || 'Not provided'), 1)
                        ]),
                        _createElementVNode("div", null, [
                          _cache[26] || (_cache[26] = _createElementVNode("div", { class: "text-sm text-slate-400" }, "Phone Number", -1)),
                          _createElementVNode("div", _hoisted_30, _toDisplayString(user.phone || 'Not provided'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_31, [
                          _cache[27] || (_cache[27] = _createElementVNode("div", { class: "text-sm text-slate-400" }, "Address", -1)),
                          _createElementVNode("div", _hoisted_32, _toDisplayString([user.address, user.city, user.state, user.zipcode].filter(Boolean).join(', ') || 'Not provided'), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_33, [
                      _createElementVNode("div", _hoisted_34, [
                        _createVNode(_unref(GraduationCap), { class: "h-5 w-5 dark:text-slate-300" }),
                        _cache[28] || (_cache[28] = _createElementVNode("h2", { class: "text-xl font-bold dark:text-white" }, "Additional Information", -1))
                      ]),
                      _createElementVNode("div", _hoisted_35, [
                        _createElementVNode("div", null, [
                          _cache[29] || (_cache[29] = _createElementVNode("div", { class: "text-sm text-slate-400" }, "Position", -1)),
                          _createElementVNode("div", _hoisted_36, _toDisplayString(user.position || 'Not provided'), 1)
                        ]),
                        _createElementVNode("div", null, [
                          _cache[30] || (_cache[30] = _createElementVNode("div", { class: "text-sm text-slate-400" }, "Gender", -1)),
                          _createElementVNode("div", _hoisted_37, _toDisplayString(user.gender || 'Not provided'), 1)
                        ]),
                        _createElementVNode("div", null, [
                          _cache[31] || (_cache[31] = _createElementVNode("div", { class: "text-sm text-slate-400" }, "Date of Birth", -1)),
                          _createElementVNode("div", _hoisted_38, _toDisplayString(formattedDateOfBirth.value !== '-' ? formattedDateOfBirth.value : 'Not provided'), 1)
                        ]),
                        _createElementVNode("div", null, [
                          _cache[32] || (_cache[32] = _createElementVNode("div", { class: "text-sm text-slate-400" }, "Zip Code", -1)),
                          _createElementVNode("div", _hoisted_39, _toDisplayString(user.zipcode || 'Not provided'), 1)
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_40, [
                    _createElementVNode("div", _hoisted_41, [
                      _createVNode(_unref(ShieldCheck), { class: "h-5 w-5 dark:text-slate-300" }),
                      _cache[33] || (_cache[33] = _createElementVNode("h2", { class: "text-xl font-bold dark:text-white" }, "Account Info", -1))
                    ]),
                    _createElementVNode("div", _hoisted_42, [
                      _createElementVNode("div", null, [
                        _cache[34] || (_cache[34] = _createElementVNode("div", { class: "text-sm text-slate-400" }, "Username", -1)),
                        _createElementVNode("div", _hoisted_43, _toDisplayString(user.username || '-'), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _cache[35] || (_cache[35] = _createElementVNode("div", { class: "text-sm text-slate-400" }, "User Type", -1)),
                        _createElementVNode("div", _hoisted_44, _toDisplayString(formattedRole.value), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _cache[36] || (_cache[36] = _createElementVNode("div", { class: "text-sm text-slate-400" }, "Account Status", -1)),
                        _createElementVNode("div", _hoisted_45, [
                          _createElementVNode("span", {
                            class: _normalizeClass(["h-2 w-2 rounded-full", user.status === 'inactive' ? 'bg-red-500' : 'bg-green-500'])
                          }, null, 2),
                          _createElementVNode("span", {
                            class: _normalizeClass(["text-base font-semibold", user.status === 'inactive' ? 'text-red-400' : 'text-green-400'])
                          }, _toDisplayString(user.status ? (user.status.charAt(0).toUpperCase() + user.status.slice(1)) : 'Active'), 3)
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_46, [
                    _createElementVNode("div", _hoisted_47, [
                      _createVNode(_unref(Lock), { class: "h-5 w-5 dark:text-slate-300" }),
                      _cache[37] || (_cache[37] = _createElementVNode("h2", { class: "text-xl font-bold dark:text-white" }, "Change Password", -1))
                    ]),
                    _createElementVNode("div", _hoisted_48, [
                      (error.value)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_49, _toDisplayString(error.value), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", null, [
                        _cache[38] || (_cache[38] = _createElementVNode("label", { class: "text-sm text-slate-400 block mb-1.5" }, "Current Password", -1)),
                        _createElementVNode("div", _hoisted_50, [
                          _withDirectives(_createElementVNode("input", {
                            type: showCurrentPw.value ? 'text' : 'password',
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((passwordForm.currentPassword) = $event)),
                            class: "w-full rounded-lg dark:bg-gray-700 border dark:border-gray-600 dark:text-white text-sm px-4 py-2.5 pr-10 outline-none focus:border-primary transition",
                            placeholder: ""
                          }, null, 8, _hoisted_51), [
                            [_vModelDynamic, passwordForm.currentPassword]
                          ]),
                          _createElementVNode("button", {
                            type: "button",
                            class: "absolute right-3 top-1/2 -translate-y-1/2 dark:text-slate-400 dark:hover:text-white transition hover:text-gray-700",
                            onClick: _cache[7] || (_cache[7] = ($event: any) => (showCurrentPw.value = !showCurrentPw.value))
                          }, [
                            (!showCurrentPw.value)
                              ? (_openBlock(), _createBlock(_unref(EyeOff), {
                                  key: 0,
                                  class: "h-4 w-4"
                                }))
                              : (_openBlock(), _createBlock(_unref(Eye), {
                                  key: 1,
                                  class: "h-4 w-4"
                                }))
                          ])
                        ])
                      ]),
                      _createElementVNode("div", null, [
                        _cache[39] || (_cache[39] = _createElementVNode("label", { class: "text-sm text-slate-400 block mb-1.5" }, "New Password", -1)),
                        _createElementVNode("div", _hoisted_52, [
                          _withDirectives(_createElementVNode("input", {
                            type: showNewPw.value ? 'text' : 'password',
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((passwordForm.newPassword) = $event)),
                            class: "w-full rounded-lg dark:bg-gray-700 border dark:border-gray-600 dark:text-white text-sm px-4 py-2.5 pr-10 outline-none focus:border-primary transition",
                            placeholder: ""
                          }, null, 8, _hoisted_53), [
                            [_vModelDynamic, passwordForm.newPassword]
                          ]),
                          _createElementVNode("button", {
                            type: "button",
                            class: "absolute right-3 top-1/2 -translate-y-1/2 dark:text-slate-400 dark:hover:text-white transition hover:text-gray-700",
                            onClick: _cache[9] || (_cache[9] = ($event: any) => (showNewPw.value = !showNewPw.value))
                          }, [
                            (!showNewPw.value)
                              ? (_openBlock(), _createBlock(_unref(EyeOff), {
                                  key: 0,
                                  class: "h-4 w-4"
                                }))
                              : (_openBlock(), _createBlock(_unref(Eye), {
                                  key: 1,
                                  class: "h-4 w-4"
                                }))
                          ])
                        ])
                      ]),
                      _createElementVNode("div", null, [
                        _cache[40] || (_cache[40] = _createElementVNode("label", { class: "text-sm text-slate-400 block mb-1.5" }, "Confirm New Password", -1)),
                        _createElementVNode("div", _hoisted_54, [
                          _withDirectives(_createElementVNode("input", {
                            type: showConfirmPw.value ? 'text' : 'password',
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((passwordForm.confirmPassword) = $event)),
                            class: "w-full rounded-lg dark:bg-gray-700 border dark:border-gray-600 dark:text-white text-sm px-4 py-2.5 pr-10 outline-none focus:border-primary transition",
                            placeholder: ""
                          }, null, 8, _hoisted_55), [
                            [_vModelDynamic, passwordForm.confirmPassword]
                          ]),
                          _createElementVNode("button", {
                            type: "button",
                            class: "absolute right-3 top-1/2 -translate-y-1/2 dark:text-slate-400 dark:hover:text-white transition hover:text-gray-700",
                            onClick: _cache[11] || (_cache[11] = ($event: any) => (showConfirmPw.value = !showConfirmPw.value))
                          }, [
                            (!showConfirmPw.value)
                              ? (_openBlock(), _createBlock(_unref(EyeOff), {
                                  key: 0,
                                  class: "h-4 w-4"
                                }))
                              : (_openBlock(), _createBlock(_unref(Eye), {
                                  key: 1,
                                  class: "h-4 w-4"
                                }))
                          ])
                        ]),
                        (passwordForm.newPassword && passwordForm.confirmPassword && passwordForm.newPassword !== passwordForm.confirmPassword)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_56, "Passwords do not match"))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("button", {
                        type: "button",
                        class: "inline-flex items-center gap-2 rounded-lg bg-red-800 hover:bg-red-700 text-white font-semibold text-sm px-5 py-2.5 transition shadow",
                        disabled: loading.value,
                        onClick: _cache[12] || (_cache[12] = ($event: any) => (handlePasswordSave(passwordForm)))
                      }, [
                        _createVNode(_unref(Lock), { class: "h-4 w-4" }),
                        _cache[41] || (_cache[41] = _createTextVNode(" Update Password ", -1))
                      ], 8, _hoisted_57)
                    ])
                  ])
                ], 64))
              : (_openBlock(), _createBlock(ProfileDocumentsTab, { key: 6 }))
        ]),
        _createVNode(ProfilePersonalModal, {
          "is-open": editing.personal,
          draft: draft,
          loading: profileLoading.value,
          positions: positions.value,
          onClose: closeAll,
          onSave: handlePersonalSave
        }, null, 8, ["is-open", "draft", "loading", "positions"]),
        _createVNode(ProfileEmailModal, {
          "is-open": editing.email,
          draft: draft,
          loading: loading.value,
          onClose: closeAll,
          onSave: handleEmailSave
        }, null, 8, ["is-open", "draft", "loading"]),
        _createVNode(ProfilePasswordModal, {
          "is-open": editing.password,
          "password-form": passwordForm,
          loading: loading.value,
          error: error.value,
          onClose: closeAll,
          onSave: handlePasswordSave
        }, null, 8, ["is-open", "password-form", "loading", "error"]),
        _createVNode(Modal, {
          "model-value": editing.avatar,
          title: "Crop Profile Photo",
          size: "medium",
          "onUpdate:modelValue": closeAll
        }, {
          footer: _withCtx(() => [
            _createElementVNode("button", {
              type: "button",
              class: "inline-flex items-center justify-center rounded-xl border border-slate-200 bg-white px-4 py-2 text-sm font-semibold text-slate-700 hover:bg-slate-50",
              onClick: closeAll
            }, " Cancel "),
            _createElementVNode("button", {
              type: "button",
              class: "inline-flex items-center justify-center rounded-xl bg-gradient-to-r from-primary to-secondary px-4 py-2 text-sm font-semibold text-white shadow-sm hover:brightness-110 transition disabled:cursor-not-allowed disabled:opacity-60",
              disabled: loading.value,
              onClick: handleCropAndSave
            }, " Save ", 8, _hoisted_63)
          ]),
          default: _withCtx(() => [
            (avatarPreview.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                  _cache[44] || (_cache[44] = _createElementVNode("label", { class: "mb-1 block text-xs font-semibold text-slate-700" }, [
                    _createTextVNode(" Crop your image "),
                    _createElementVNode("span", { class: "font-normal text-slate-400" }, "— drag to adjust")
                  ], -1)),
                  _createElementVNode("div", _hoisted_59, [
                    _createVNode(_unref(VueCropper), {
                      ref_key: "cropperRef",
                      ref: cropperRef,
                      src: avatarPreview.value,
                      "aspect-ratio": 1,
                      "view-mode": 1,
                      guides: true,
                      "auto-crop-area": 0.8,
                      background: false,
                      zoomable: true,
                      rotatable: true
                    }, null, 8, ["src"])
                  ]),
                  _createElementVNode("div", _hoisted_60, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "px-3 py-1.5 rounded-lg text-xs font-medium text-slate-600 hover:bg-slate-100 transition",
                      onClick: _cache[13] || (_cache[13] = ($event: any) => (rotateCropper(-90)))
                    }, [
                      _createVNode(_unref(RotateCcw), { class: "w-4 h-4" })
                    ]),
                    _createElementVNode("button", {
                      type: "button",
                      class: "px-3 py-1.5 rounded-lg text-xs font-medium text-slate-600 hover:bg-slate-100 transition",
                      onClick: _cache[14] || (_cache[14] = ($event: any) => (rotateCropper(90)))
                    }, [
                      _createVNode(_unref(RotateCw), { class: "w-4 h-4" })
                    ]),
                    _cache[43] || (_cache[43] = _createElementVNode("div", { class: "flex-1" }, null, -1)),
                    _createElementVNode("label", _hoisted_61, [
                      _cache[42] || (_cache[42] = _createTextVNode(" Change Image ", -1)),
                      _createElementVNode("input", {
                        type: "file",
                        accept: "image/*",
                        class: "hidden",
                        onChange: handleFileSelected
                      }, null, 32)
                    ])
                  ]),
                  (error.value)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_62, _toDisplayString(error.value), 1))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["model-value"]),
        _createVNode(Modal, {
          modelValue: showAvatarPreview.value,
          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((showAvatarPreview).value = $event)),
          title: "Profile Photo",
          size: "small"
        }, {
          footer: _withCtx(() => [
            _createElementVNode("button", {
              type: "button",
              class: "px-4 py-2 rounded-lg border border-gray-300 dark:border-gray-600 text-sm font-medium text-secondary-text dark:text-secondary-dark-text hover:bg-gray-100/80 dark:hover:bg-gray-700/60 transition-colors",
              onClick: _cache[15] || (_cache[15] = ($event: any) => (showAvatarPreview.value = false))
            }, "Close")
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_64, [
              _createElementVNode("img", {
                src: user.avatar,
                alt: "profile",
                class: "max-w-full max-h-[70vh] rounded-lg"
              }, null, 8, _hoisted_65)
            ])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ])
  ]))
}
}

})